import { FormControlLabel, Switch } from "@mui/material"
import type { FC } from "react"

interface Props {
  onChange: () => void
  isActive: boolean
}

export const HideInactiveMethodsSwitch: FC<Props> = ({ onChange, isActive }) => {
  return (
    <FormControlLabel
      control={<Switch checked={isActive} onChange={onChange} size='small' />}
      label='Hide Inactive Methods'
    />
  )
}
